import { useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { SponsorLogo, SponsorCard } from "@/components/SponsorsCarousel";

const Chip = ({ s, small, testId }) => {
  const [open, setOpen] = useState(false);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" onClick={(e) => e.stopPropagation()} title={s.name} data-testid={testId}
          className={`${small ? "h-10 px-2" : "h-14 px-3"} shrink-0 grid place-items-center bg-white rounded-md border border-[#E5E7EB] hover:border-[#E60000] transition-colors`}>
          <SponsorLogo s={s} className={small ? "h-7 text-xs" : "h-10 text-sm"} />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-72" sideOffset={8}><SponsorCard s={s} onClose={() => setOpen(false)} /></PopoverContent>
    </Popover>
  );
};

export const EventSponsors = ({ sponsors, variant = "light", testId }) => {
  const list = (sponsors || []).filter((s) => s.active !== false);
  if (!list.length) return null;
  const dark = variant === "dark";
  const print = variant === "print";
  return (
    <div className={dark ? "mt-5" : "mt-4"} data-testid={testId}>
      <div className={`text-[10px] font-bold uppercase tracking-[0.18em] mb-2 ${dark ? "text-white/50" : "text-gray-500"}`}>Sponsored by</div>
      <div className={dark ? "flex items-center gap-2 overflow-x-auto pb-1 [scrollbar-width:thin] [mask-image:linear-gradient(to_right,black_85%,transparent)]" : "flex flex-wrap items-center gap-2"} data-testid={`${testId}-row`}>
        {list.map((s) => print
          ? <span key={s.id} className="h-10 px-2 grid place-items-center border border-[#E5E7EB] rounded" data-testid={`${testId}-item-${s.id}`}><SponsorLogo s={s} className="h-7 text-xs" /></span>
          : <Chip key={s.id} s={s} small={dark} testId={`${testId}-item-${s.id}`} />)}
      </div>
    </div>
  );
};
